export const actions = {
    SET_USER: 'SET_USER',
    UPDATE_USER: 'UPDATE_USER',
    SET_ADMIN_ACCESS: 'SET_ADMIN_ACCESS',
    SET_USER_ACCESS: 'SET_USER_ACCESS',
};
